__turbopack_context__.v({
  "SCloseSvg": "wHYSfq_SCloseSvg",
});
